import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'
import { TimeoffEmployeeRootPageDocument } from 'generated/resources/graphql'

import ErrorBoundary from 'modules/core/components/ErrorBoundary'
import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import TimeoffCard from 'modules/timeoff/components/Card'
import CollectionsBootstrap from 'modules/timeoff/lib/EmployeesCollectionsBootstrap'
import { LeavesContextProvider } from 'modules/timeoff/lib/LeavesContextProvider'
import { ContractsVersionProvider } from 'modules/timeoff/lib/contractsVersionContext'

const Container = () => {
  const { id: employeeId } = useStrictParams<'id'>()

  const { data, loading, error } = useQuery(TimeoffEmployeeRootPageDocument, {
    variables: {
      employeeId: String(employeeId),
      featureId: Features.timeoff_manual_adjustment_options,
    },
  })

  if (loading) {
    return <Loading />
  }

  const employeeData = data?.employees.employee

  if (error || !employeeData) {
    return (
      <ResponsivePage.Body variant="full" showHeader={false}>
        <Box padding="s0">
          <ErrorBoundary />
        </Box>
      </ResponsivePage.Body>
    )
  }

  const hasManualAdjustmentOptions =
    !!data?.companies.featureAvailabilitiesConnection.nodes[0]?.available

  return (
    <ContractsVersionProvider employeeId={employeeData.id}>
      <LeavesContextProvider>
        <ResponsivePage.Body variant="full" showHeader={false}>
          <TimeoffCard
            employeeData={employeeData}
            hasManualAdjustmentOptions={hasManualAdjustmentOptions}
          >
            <Outlet />
          </TimeoffCard>
        </ResponsivePage.Body>
      </LeavesContextProvider>
    </ContractsVersionProvider>
  )
}
const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
